import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  metaInfo() {
    if (this.opportunity) {
      return {
        title: this.opportunity.data.attributes.name,
      };
    }
    return {
      title: 'Nouvelle opportunité',
    };
  },
  computed: {
    ...mapState('opportunity', {
      opportunity: state => state.show,
    }),
    ...mapGetters('opportunity', ['canDecline', 'canInvest', 'currentUserWish', 'canAccept']),
  },
  created() {
    const opportunityId = this.$route.params.id;
    if (!opportunityId) return;
    this.fetch({ id: opportunityId }).then((response) => {
      if (response && this.currentUserWish) {
        const { attributes } = this.currentUserWish;
        if (attributes.acceptedAmount && !attributes.acceptedAt
              && !sessionStorage[`seen${opportunityId}`] &&
              response.data.data.attributes.enteredAdministrativePhaseAt) {
          sessionStorage[`seen${opportunityId}`] = true;
          this.$router.push(`/opportunities/${opportunityId}/accept`);
        }
      }
    });
  },
  methods: mapActions('opportunity', ['fetch']),
};
